/**
 * Consolidated status and priority formatting utilities
 */

import { toLower } from './stringFormatting'

/**
 * Valid job statuses
 */
export const STATUS_CHIP_CLASS = {
  Pending: 'gg-calendar-chip gg-calendar-chip--pending',
  Scheduled: 'gg-calendar-chip gg-calendar-chip--scheduled',
  Completed: 'gg-calendar-chip gg-calendar-chip--completed'
}

/**
 * Normalize a job status to valid form
 * @param {string} status - Raw status value
 * @returns {string} Normalized status (one of ALLOWED_STATUSES)
 */
export const normalizeStatus = (status) => {
  if (!status) return 'Pending'
  const lower = toLower(status)
  if (lower === 'pending') return 'Pending'
  if (lower === 'scheduled') return 'Scheduled'
  if (lower === 'completed') return 'Completed'
  return 'Pending'
}

/**
 * Convert announcement priority to UI status type
 * @param {string} value - Priority value (e.g., 'urgent', 'important', 'normal')
 * @returns {string} Status type for styling (e.g., 'error', 'warning', 'info')
 */
export const toPriorityStatus = (value) => {
  const normalized = toLower(value)
  if (normalized === 'urgent') return 'error'
  if (normalized === 'important') return 'warning'
  return 'info'
}
